export default __webpack_public_path__ + "locales/az/ChangeUserTypeDialog.json?hash=dd8a309c6b1ee3bcf99b1f5568af116b";